import {Component, computed, ElementRef, ViewChild, Input, Type } from '@angular/core';
import {AppMenu} from './app.menu';
import {LayoutService} from '../service/layout.service';
import { Router, RouterModule} from '@angular/router';
import {CommonModule} from "@angular/common";

@Component({
    selector: 'app-sidebar',
    standalone: true,
    imports: [CommonModule, AppMenu, RouterModule],
    template: `<div class="layout-sidebar" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
        <div class="sidebar-header">
            @if (menuBackLink) {
                <a class="logo back flex items-center" [routerLink]="menuBackLink.routerLink">
                    @if (menuBackLink.icon) {
                        <i class="{{ menuBackLink.icon }} mr-2"></i>
                    }
                    <span>{{ menuBackLink.label }}</span>
                </a>
            }
            @else {
                <a class="logo" (click)="logoClick()" [routerLink]="['/']">
                    <img *ngIf="logoSrc" class="logo-image" [src]="logoSrc" [alt]="logoAlt" />
                    <span *ngIf="title" class="app-name title-h7">{{ title }}</span>
                </a>
                <button class="layout-sidebar-anchor z-2" type="button" (click)="anchor()"></button>
            }
        </div>

        @if (beforeMenuSlot) {
            <ng-container *ngComponentOutlet="beforeMenuSlot"></ng-container>
        }

        <div #menuContainer class="layout-menu-container">
            <app-menu [menuData]="menuData" />
        </div>
        <!--
        <div app-topbar *ngIf="isHorizontal()"></div>
        -->
    </div>`
})
export class AppSidebar {
    @Input({ required: true }) logoSrc!: string;
    @Input({ required: true }) logoAlt!: string;
    @Input({ required: true }) title!: string;
    @Input({ required: false }) beforeMenuSlot?: Type<any> | null = null;
    @Input({ required: true }) menuData!: any[];
    @Input({ required: false }) menuBackLink?: any;
    @Input() onLogoClick?: () => void;
    timeout: any = null;

    isHorizontal = computed(() => this.layoutService.isHorizontal());

    menuTheme = computed(() => this.layoutService.layoutConfig().menuTheme);

    @ViewChild('menuContainer') menuContainer!: ElementRef;

    constructor(
        public layoutService: LayoutService,
        public el: ElementRef,
        private readonly router: Router,
    ) {}

    onMouseEnter() {
        if (!this.layoutService.layoutState().anchored) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }

            this.layoutService.layoutState.update((state) => {
                if (!state.sidebarActive) {
                    return {
                        ...state,
                        sidebarActive: true
                    };
                }
                return state;
            });
        }
    }

    onMouseLeave() {
        if (!this.layoutService.layoutState().anchored) {
            if (!this.timeout) {
                this.timeout = setTimeout(() => {
                    this.layoutService.layoutState.update((state) => {
                        if (state.sidebarActive) {
                            return {
                                ...state,
                                sidebarActive: false
                            };
                        }
                        return state;
                    });
                }, 300);
            }
        }
    }

    anchor() {
        this.layoutService.layoutState.update((state) => ({
            ...state,
            anchored: !state.anchored
        }));
    }

    logoClick() {
        if (this.onLogoClick) {
            this.onLogoClick();
        }
        else {
            void this.router.navigateByUrl('/');
        }
    }
}
